'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementsModal = exports.AnnouncementsModalUnwrapped = exports.mapStateToProps = exports.mapDispatchToProps = exports.modalConfig = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deep = require('helpers/deep');

var _announcements = require('./announcements.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalConfig = exports.modalConfig = {
  hideClose: true,
  isPersistent: true,
  headerClass: 'modal--small'
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  acceptAnnouncement: _announcements.acceptAnnouncement
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    userAnnouncements: _bound.userAnnouncements.select(state, _bound.userAnnouncements.lastRequestedKey(state))
  };
};

var AnnouncementsModalUnwrapped = exports.AnnouncementsModalUnwrapped = function (_Component) {
  (0, _inherits3.default)(AnnouncementsModalUnwrapped, _Component);

  function AnnouncementsModalUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, AnnouncementsModalUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = AnnouncementsModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(AnnouncementsModalUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleClick = function () {
      var localUserAnnouncement = _this.props.userAnnouncements;

      var referenceHash = (0, _deep.deepExtract)('data.announcements.0.reference_hash', localUserAnnouncement);
      _this.props.acceptAnnouncement(referenceHash);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(AnnouncementsModalUnwrapped, [{
    key: 'render',
    value: function render() {
      var localUserAnnouncement = this.props.userAnnouncements;

      var _deepExtract = (0, _deep.deepExtract)('data.announcements.0', localUserAnnouncement, {}),
          headerText = _deepExtract.header_text,
          subheaderText = _deepExtract.subheader_text,
          buttonText = _deepExtract.button_text,
          footerLink = _deepExtract.footer_link,
          footerText = _deepExtract.footer_text;

      return _react2.default.createElement(
        'div',
        { className: 'modal__announcements' },
        headerText && _react2.default.createElement(
          'h3',
          null,
          headerText
        ),
        // eslint-disable-next-line react/no-danger
        subheaderText && _react2.default.createElement('p', { className: 'modal__announcements__subheader mb+ mt', dangerouslySetInnerHTML: { __html: subheaderText } }),
        buttonText && _react2.default.createElement(
          'button',
          {
            className: 'bt bt--primary bt--width-full mb',
            onClick: this.handleClick
          },
          buttonText
        ),
        footerLink && footerText && _react2.default.createElement(
          'a',
          {
            href: footerLink,
            className: 'modal__announcements__need-help'
          },
          footerText
        )
      );
    }
  }]);
  return AnnouncementsModalUnwrapped;
}(_react.Component);

AnnouncementsModalUnwrapped.propTypes = {
  acceptAnnouncement: _propTypes2.default.func.isRequired,
  userAnnouncements: _propTypes2.default.object.isRequired
};

var AnnouncementsModal = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _Modal2.default)(modalConfig)(AnnouncementsModalUnwrapped));
exports.AnnouncementsModal = AnnouncementsModal;